import DashboardLayout from "src/layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "src/views/NotFoundPage.vue";
// Dashboard pages
import Dashboard from "src/views/Dashboard.vue";
import Session from "src/views/Session.vue";
import AccessDenied from "src/views/AccessDenied.vue";
import Main from "src/views/Main.vue";
import Forma4 from "src/views/Forma4.vue";

import CallCenterMain from "@/views/callcenter/Main.vue";
import CallCenterAllAccidents from "@/views/callcenter/AllAccidents.vue";
import ActiveAppraisal from "@/views/callcenter/ActiveAppraisal.vue";
import AppraisalForm from "@/views/callcenter/AppraisalForm.vue";
import AccidentClientFormCC from "@/views/callcenter/AccidentClientForm.vue";
import ClaimFormCC from "@/views/callcenter/ClaimForm.vue";

import AccidentCommMain from "@/views/comm/Main.vue";
import AccidentCommForm from "@/views/comm/AccidentCommForm.vue";

import CommAccidents from "@/views/comm/CommAccidents.vue";
import CommAllAccidents from "@/views/comm/AllAccidents.vue";
import CommSchedule from "@/views/comm/AccidentCommSchedule.vue";

import AccidentClientForm from "@/views/servicecenter/AccidentClientForm.vue";
import ClaimForm from "@/views/servicecenter/ClaimForm.vue";
import ServiceCenterMain from "@/views/servicecenter/Main.vue";
import Accidents from "@/views/servicecenter/Accidents.vue";
import ActiveAccidents from "@/views/servicecenter/ActiveAccidents.vue";
import ActiveClaims from "@/views/servicecenter/ActiveClaims.vue";
import ClientServiceAssignments from "@/views/servicecenter/ClientServiceAssignments.vue";

import ClaimTechExpertForm from "@/views/techexpert/ClaimTechExpertForm.vue";
import TechExpertMain from "@/views/techexpert/Main.vue";
import ActiveClaimsTechExpert from "@/views/techexpert/ActiveClaims.vue";
import AllClaimsTechExpert from "@/views/techexpert/Claims.vue";
import TechExpertApproval from "@/views/techexpert/TechExpertApproval.vue";
import TechExpertRepairs from "@/views/techexpert/TechExpertRepairs.vue";
import AccidentTechExpertForm from "@/views/techexpert/AccidentTechExpertForm.vue";

import LegalExpertForm from "@/views/legalexpert/LegalExpertForm.vue";
import LegalExpertClaims from "@/views/legalexpert/LegalExpertClaims.vue";
import LegalExpertMain from "@/views/legalexpert/Main.vue";

import ActApprovalMain from "@/views/actapprovals/Main.vue";
import AccidentDetail from "@/views/actapprovals/AccidentDetail.vue";
import ApprovalClaimForm from "@/views/actapprovals/ClaimForm.vue";

import ActPrint from "@/views/components/ActPrint.vue";

import Contracts from "@/views/adm/Contracts.vue";
import ResponsibleMain from "@/views/adm/Main.vue";
import CommApproval from "@/views/adm/CommApproval.vue";
import NewSigner from "@/views/adm/NewSigner.vue";
import CommRegion from "@/views/adm/CommRegion.vue";

import PaymentMain from "@/views/payment/Main.vue";
import AllClaimPayment from "@/views/payment/AllClaims.vue";
import PaymentForm from "@/views/payment/PaymentForm.vue";
import PaymentAccidentForm from "@/views/payment/AccidentClientForm.vue";


//report
import AccidentCountReport from "@/views/report/AccidentCount.vue";
import BtzAccidents from "@/views/report/BtzAccidents.vue";
import AccidentsReport from "@/views/report/AccidentsReport.vue"
import AccidentsFullInfo from "@/views/report/AccidentsFullInfo"
import PowerBi from "@/views/report/PowerBi"

//carep

import CarepMain from "@/views/carep/Main.vue";
import CarepForm from "../views/carep/CarepForm.vue";


let callCenter = {
  path: "/callcenter",
  component: DashboardLayout,
  name: "Çağrı mərkəzi",
  redirect: "/callcenter/main",
  children: [
    {
      path: "main",
      name: "Müraciətlər",
      components: { default: CallCenterMain },
      meta: {
        requiresAuth: true,
        role: ["Call center manager", "Call center operator", "Client service viewer", "Main"],
        stage: 1
      },
    },
    {
      path: "appraisal",
      name: "Müştəri ilə razılaşdırılma",
      components: { default: ActiveAppraisal },
      meta: {
        requiresAuth: true,
        role: ["Call center manager", "Call center operator", "Call center viewer"],
      },
    },
    {
      path: "claim/:id?",
      name: "İş - Çağrı mərkəzi",
      props: { default: true },
      components: { default: AppraisalForm },
      meta: {
        requiresAuth: true,
        role: ["Call center manager", "Call center operator", "Call center viewer"],
      },
    },
    {
      path: "all/accidents",
      name: "Axtarış - Çağrı mərkəzi",
      components: { default: CallCenterAllAccidents },
      meta: {
        requiresAuth: true,
        role: ["Call center manager", "Call center operator", "Call center viewer"],
      },
    },
    {
      path: "all/accident/:id?",
      name: "Hadisə",
      props: { default: true },
      components: { default: AccidentClientFormCC },
      meta: {
        requiresAuth: true,
        role: ["Call center manager", "Call center operator", "Call center viewer"],
      },
    },
    {
      path: "all/claim/:id?",
      name: "Cari iş",
      props: { default: true },
      components: { default: ClaimFormCC },
      meta: {
        requiresAuth: true,
        role: ["Call center manager", "Call center operator", "Call center viewer"],
      },
    },
  ],
};

let accidentComm = {
  path: "/comm",
  component: DashboardLayout,
  name: "Qəza komissarı",
  redirect: "/comm/main",
  children: [
    {
      path: "main",
      name: "Cari hadisələr",
      components: { default: AccidentCommMain },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
        stage: 2
      },
    },
    {
      path: "accident/:id?",
      name: "Hadisə - Qəza komissarı",
      props: { default: true },
      components: { default: AccidentCommForm },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
        note: true
      },
    },
    {
      path: "accidents",
      name: "Hadisələr",
      props: { default: true },
      components: { default: CommAccidents },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
      },
    },
    {
      path: "all/accidents",
      name: "Axtarış - Qəza komissarı",
      props: { default: true },
      components: { default: CommAllAccidents },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
      },
    },
    {
      path: "schedule",
      name: "İş qrafiki - Qəza komissarı",
      props: { default: true },
      components: { default: CommSchedule },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
      },
    },
    {
      path: "commregion",
      name: "Komissarların ərazi bölgüsü",
      components: { default: CommRegion },
      meta: {
        requiresAuth: true,
        role: ["Director of ICD"],
      },
    },
  ],
};


let carep = {
  path: "/carep",
  component: DashboardLayout,
  name: "Təmir mərkəzlərinin idarə sistemi",
  redirect: "/carep/main",
  children: [
    {
      path: "/carep",
      name: "Təmir mərkəzlərinin idarə sistemi",
      components: { default: CarepMain },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar operator", "Accident commissar viewer", "Accident commissar manager"],
      },
    },
    {
      path: ":id?",
      name: "Təmir mərkəzlərinin idarə sistemi",
      props: { default: true },
      components: { default: CarepForm },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
      },
    },
  ],
};


let serviceCenter = {
  path: "/servicecenter",
  component: DashboardLayout,
  name: "Müştəri xidmətləri",
  redirect: "/servicecenter/",
  children: [
    {
      path: "/servicecenter/main",
      name: "Cari hadisələr - Müştəri xidməti",
      components: { default: ServiceCenterMain },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
        stage: 3
      },
    },
    {
      path: "accidents",
      name: "Axtarış - Müştəri xidməti",
      components: { default: Accidents },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
      },
    },
    {
      path: "accident/:id?",
      name: "Hadisə - Müştəri xidməti",
      props: { default: true },
      components: { default: AccidentClientForm },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
        note: true
      },
    },
    {
      path: "claims",
      name: "Açıq hadisələr - Müştəri xidməti",
      props: { default: true },
      components: { default: ActiveAccidents },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
        stage: 3
      },
    },
    {
      path: "active-claims",
      name: "Açıq işlər - Müştəri xidməti",
      props: { default: true },
      components: { default: ActiveClaims },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
        stage: 3
      },
    },
    {
      path: "claim/:id?",
      name: "Cari iş - Müştəri xidməti",
      props: { default: true },
      components: { default: ClaimForm },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Client service operator", "Client service viewer"],
        note: true,
      },
    },
  ],
};

let techExpert = {
  path: "/techexpert",
  component: DashboardLayout,
  name: "Qiymətləndirmə",
  redirect: "/techexpert/",
  children: [
    {
      path: "/techexpert/main",
      name: "Cari hadisələr - Qiymətləndirmə",
      components: { default: TechExpertMain },

      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
        stage: 4
      },
    },
    {
      path: "accident/:id?",
      name: "Hadisə - Qiymətləndirmə",
      props: { default: true },
      components: { default: AccidentTechExpertForm },
      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
      },
    },
    {
      path: "claim/:id?",
      name: "Cari iş - Qiymətləndirmə",
      props: { default: true },
      components: { default: ClaimTechExpertForm },
      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
        note: true
      },
    },
    {
      path: "approval",
      name: "Razılaşdırılma",
      components: { default: TechExpertApproval },
      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
        stage: 4
      },
    },
    {
      path: "claims",
      name: "Cari işlər - Qiymətləndirmə",
      components: { default: ActiveClaimsTechExpert },
      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
        stage: 4
      },
    },
    {
      path: "all/claims",
      name: "Axtarış- Qiymətləndirmə",
      components: { default: AllClaimsTechExpert },
      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
      },
    },
    {
      path: "repairs",
      name: "Təmirdə olanlar",
      components: { default: TechExpertRepairs },
      meta: {
        requiresAuth: true,
        role: ["Tech expertise manager", "Tech expertise operator", "Tech expertise viewer"],
        stage: 4
      },
    },

  ],
};

let legalExpert = {
  path: "/legalexpert",
  component: DashboardLayout,
  name: "Hüquqi ekspertiza",
  redirect: "/legalexpert/",
  children: [
    {
      path: "/legalexpert/main",
      name: "Cari işlər - Hüquqi ekspertiza",
      components: { default: LegalExpertMain },
      meta: {
        requiresAuth: true,
        role: ["Legal operator", "Client service operator"],
        stage: 5
      },
    },
    {
      path: "claims",
      name: "Axtarış - Hüquqi ekspertiza",
      components: { default: LegalExpertClaims },
      meta: {
        requiresAuth: true,
        role: ["Legal operator", "Client service operator"],
      },
    },
    {
      path: "claim/:id?",
      name: "Cari iş - Hüquqi ekspertiza",
      props: { default: true },
      components: { default: LegalExpertForm },
      meta: {
        requiresAuth: true,
        role: ["Legal operator", "Client service operator"],
      },
    },

  ],
};

let actapprovals = {
  path: "/approval",
  component: DashboardLayout,
  name: "Təsdiqlənmə",
  redirect: "/approval/",
  children: [
    {
      path: "main/",
      name: "Təsdiqlənmə Main",
      props: { default: true },
      components: { default: ActApprovalMain },
      meta: {
        requiresAuth: true,
        role: ["Chairman", "Advisor", "Assistant Chairman", "Director of ICD", "Assistant Director of ICD", "Administrative operator", "Inspection commission operator 1", "Inspection commission operator 2", "Manager of ICAD"],
        stage: 6
      },
    },
    {
      path: "view/:id?",
      name: "Act forması - Təsdiqlənmə",
      props: { default: true },
      components: { default: ActPrint },
      meta: {
        requiresAuth: true,
        role: ["Chairman", "Advisor", "Assistant Chairman", "Director of ICD", "Assistant Director of ICD", "Administrative operator", "Inspection commission operator 1", "Inspection commission operator 2", "Manager of ICAD"],
      },
    },
    {
      path: "detail/:accidentId?/:claimId?",
      name: "Qəza məlumatları",
      props: { default: true },
      components: { default: AccidentDetail },
      meta: {
        requiresAuth: true,
        role: ["Chairman", "Advisor", "Assistant Chairman", "Director of ICD", "Assistant Director of ICD", "Administrative operator", "Inspection commission operator 1", "Inspection commission operator 2", "Manager of ICAD"],

      },
    },
    {
      path: "claim/:id?/:actId?",
      name: "Cari iş - Təsdiqləmə",
      props: { default: true },
      components: { default: ApprovalClaimForm },
      meta: {
        requiresAuth: true,
        role: ["Chairman", "Advisor", "Assistant Chairman", "Director of ICD", "Assistant Director of ICD", "Administrative operator", "Inspection commission operator 1", "Inspection commission operator 2", "Manager of ICAD"],
        note: true
      },
    },
  ],
};


let adm = {
  path: "/adm",
  component: DashboardLayout,
  name: "İnzibati işlər",
  redirect: "/adm/contract",
  children: [
    {
      path: "contract",
      name: "Müqavilələr",
      components: { default: Contracts },
      meta: {
        requiresAuth: true,
        role: ["Administrative operator"],
      },
    },
    {
      path: "responsible",
      name: "İçraçı təyinatı",
      components: { default: ResponsibleMain },
      meta: {
        requiresAuth: true,
        role: ["Client service manager", "Director of ICD"],
      },
    },
        {
      path: "client-service-assignments",
      name: "İçraçı təyinatı",
      components: { default: ClientServiceAssignments },
      meta: {
        requiresAuth: true,
        role: ["Client service manager","Director of ICD"],
      },
    },
    {
      path: "commapprove",
      name: "Qəza komissarı ",
      components: { default: CommApproval },
      meta: {
        requiresAuth: true,
        role: ["Accident commissar manager", "Administrative operator"],
      },

    },
    {
      path: "create-signer",
      name: "Təsdiqləyicilər",
      components: { default: NewSigner },
      meta: {
        requiresAuth: true,
        role: ["Director of ICD"],
      },
    },
  ],
};


let payment = {
  path: "/payment",
  component: DashboardLayout,
  name: "Ödəniş",
  redirect: "/payment/",
  children: [
    {
      path: "main/",
      name: "Cari işlər - Ödəniş",
      props: { default: true },
      components: { default: PaymentMain },
      meta: {
        requiresAuth: true,
        role: ["Payment manager", "Payment operator", "Payment viewer"],
        stage: 7
      },
    },
    {
      path: "all/claims/",
      name: "Axtarış - Ödəniş",
      props: { default: true },
      components: { default: AllClaimPayment },
      meta: {
        requiresAuth: true,
        role: ["Payment manager", "Payment operator", "Payment viewer"],
        stage: 7
      },
    },
    {
      path: "view/:id?",
      name: "Act forması",
      props: { default: true },
      components: { default: ActPrint },
      meta: {
        requiresAuth: true,
        role: ["Payment manager", "Payment operator", "Payment viewer"],
      },
    },
    {
      path: "claim/:id?",
      name: "Cari iş - Ödəniş",
      props: { default: true },
      components: { default: PaymentForm },
      meta: {
        requiresAuth: true,
        role: ["Payment manager", "Payment operator", "Payment viewer"],
        note: true
      },
    },
    {
      path: "accident/:id?",
      name: "Hadisə - Ödəniş",
      props: { default: true },
      components: { default: PaymentAccidentForm },
      meta: {
        requiresAuth: true,
        role: ["Payment manager", "Payment operator", "Payment viewer"],
      },
    },
  ],
};

let session = {
  path: "/session/:id?",
  name: "session",
  props: { default: true },
  components: { default: Session },
};

let accdenied = {
  path: "/accessdenied",
  name: "Access denied",
  component: DashboardLayout,
  redirect: "/accessdenied",
  children: [
    {
      name: "Access denied - Main",
      path: "/accessdenied",
      props: { default: true },
      components: { default: AccessDenied },
    },
  ],
};


let search = {
  path: "/search",
  name: "Axtarış",
  component: DashboardLayout,
  redirect: "/search",
  children: [
    {
      name: "Axtarış - Main",
      path: "/search",
      props: { default: true },
      components: { default: Main },
      meta: {
        requiresAuth: true,
        role: ["Chairman", "Assistant Chairman", "Advisor", "Director of ICD", "Assistant Director of ICD", "Payment manager", "Payment viewer"],
      },
    },
  ],
};

let forma4 = {
  path: "/forma4",
  name: "Forma 4 axtarışı",
  component: DashboardLayout,
  redirect: "/forma4",
  children: [
    {
      name: "Forma 4 axtarışı - child",
      path: "/forma4",
      props: { default: true },
      components: { default: Forma4 },
      meta: {
        requiresAuth: true,
        role: ["Call center operator",
          "Accident commissar operator",
          "Client service operator",
          "Tech expertise operator",
          "Legal operator",
          "Approval operator"],
      },
    },
  ],
};


let report = {
  path: "/report",
  component: DashboardLayout,
  name: "Report",
  redirect: "/report/accidentCount",
  children: [
    {
      path: "accidentCount",
      name: "Hadisə sayları",
      components: { default: AccidentCountReport },
      meta: {
        requiresAuth: true,
        role: ["Accident report count"],
      },
    },
    {
      path: "accidentbtz",
      name: "BTZ hadisələri",
      components: { default: BtzAccidents },
      meta: {
        requiresAuth: true,
        role: ["Accident report BTZ"],
      },
    },
    {
      path: "accidentDetails",
      name: "Hadisə məlumatları",
      components: { default: AccidentsReport },
      meta: {
        requiresAuth: true,
        role: ["Accident detail report"],
      },
    },
    {
      path: "accidentFullDetails",
      name: "Hadisə detalları",
      components: { default: AccidentsFullInfo },
      meta: {
        requiresAuth: true,
        role: ["Accident detail report"],
      },
    },
    {
      path: "powerBi",
      name: "Hadisələrin analizi",
      components: { default: PowerBi },
      meta: {
        requiresAuth: true,
        role: ["Accident detail report"],
      },
    }

  ],
};


const routes = [
  session,
  accdenied,
  callCenter,
  accidentComm,
  serviceCenter,
  techExpert,
  legalExpert,
  actapprovals,
  adm,
  search,
  forma4,
  payment,
  report,
  carep,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Ana səhifə",
        components: { default: Dashboard },
        meta: {
          requiresAuth: true,
          role: ["Call center operator",
            "Accident commissar operator",
            "Client service operator",
            "Tech expertise operator",
            "Legal operator",
            "Approval operator",
            "Payment viewer"
          ],
        },
      },
    ],
  },

  { path: "*", component: NotFound },
];

export default routes;
